import { render, staticRenderFns } from "./ConfigPenaltyPopup.vue?vue&type=template&id=7f3803a0&"
import script from "./ConfigPenaltyPopup.vue?vue&type=script&lang=js&"
export * from "./ConfigPenaltyPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports